import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const EMPTY = { name: "", clinic: "", email: "", phone: "", message: "" };

export function ClinicContact({ open, onOpenChange }) {
  const [f, setF] = useState(EMPTY);
  const [mail, setMail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setSent(false); api.get("/public/contact").then((r) => setMail(r.data.email)); } }, [open]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/public/clinic-request", f); setSent(true); setF(EMPTY); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const mailto = `mailto:${mail}?subject=${encodeURIComponent("New clinic account request")}`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="clinic-contact-dialog">
        <DialogHeader><DialogTitle>Create a clinic account</DialogTitle></DialogHeader>
        {sent ? (
          <div className="py-6 text-center space-y-2" data-testid="clinic-contact-sent"><CheckCircle2 className="h-10 w-10 text-primary mx-auto" /><p className="font-semibold">Thank you! We'll be in touch soon.</p></div>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="clinic-contact-form">
            <p className="text-sm text-muted-foreground">Tell us about your clinic and we'll set up your account.</p>
            <div className="grid sm:grid-cols-2 gap-3">
              <Input required data-testid="clinic-contact-name" placeholder="Your name" value={f.name} onChange={set("name")} />
              <Input required data-testid="clinic-contact-clinic" placeholder="Clinic name" value={f.clinic} onChange={set("clinic")} />
              <Input required type="email" data-testid="clinic-contact-email" placeholder="Email" value={f.email} onChange={set("email")} />
              <Input type="tel" data-testid="clinic-contact-phone" placeholder="Phone" value={f.phone} onChange={set("phone")} />
            </div>
            <Textarea rows={3} data-testid="clinic-contact-message" placeholder="Anything we should know? (optional)" value={f.message} onChange={set("message")} />
            <Button className="w-full rounded-full" data-testid="clinic-contact-submit" disabled={busy}>{busy ? "Sending…" : "Send request"}</Button>
            {mail && <a href={mailto} className="flex items-center justify-center gap-2 text-sm text-primary hover:underline" data-testid="clinic-contact-mailto"><Mail className="h-4 w-4" />Or email us directly</a>}
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
